import BasicLayout from "@/layouts/basic-layout";

const meta = {
    auth: false,
    cache: false,
};
export default {
    path: "/party",
    name: "party",
    redirect: {
        name: "party",
    },
    meta,
    component: BasicLayout,
    children: [
        {
            path: "/party/list",
            name: "partyList",
            meta: {
                ...meta,
                title: "党组织管理",
                cache: true,
            },
            component: () => import("@/pages/party/PartyList.vue"),
        },
        {
            path: "/party/add",
            name: "partyAdd",
            meta: {
                ...meta,
                title: "党组织新增",
            },
            component: () => import("@/pages/party/PartyAdd.vue"),
        },
        {
            path: "/party/member/list",
            name: "partyMemberList",
            meta: {
                ...meta,
                title: "党员管理",
            },
            component: () => import("@/pages/party/PartyMemberList.vue"),
        },
    ],
};
